<template>
  <div>
    <div v-for="(item, index) in recordList" :key="index">
      <div class="record-box">
        <div class="record-container1">
          <div class="point"></div>
          <div class="operate">{{ item.auditTypeResult }}</div>
        </div>
        <div class="record-container2">
          <div class="line"></div>
          <div class="container">
            <p>
              {{
                item.auditTypeResult.indexOf("审") != -1 ? "审核" : "操作"
              }}人员：{{ item.staffName }}
            </p>
            <p>
              {{
                item.auditTypeResult.indexOf("审") != -1 ? "审核" : "操作"
              }}时间：{{ item.createTime }}
            </p>
            <p
              v-if="
                !(
                  item.auditTypeResult == '提交' ||
                  item.auditTypeResult == '结算' ||
                  item.auditTypeResult == '撤回' ||
                  item.auditTypeResult == '取消'
                )
              "
            >
              {{
                item.auditTypeResult.indexOf("审") != -1 ? "审核" : "操作"
              }}结果：{{ item.statusResult }}
            </p>
            <p v-if="item.remarkzh">
            <span v-if="item.auditTypeResult=='加签'&&item.status!=3">加签原因：
            </span><span v-else>驳回原因：</span>
             {{ item.remarkzh }}</p>
            
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    recordList: {
      type: Array,
      default: () => {}
    }
  }
};
</script>

<style lang="scss" scoped>
.record-box {
  padding-left: 68px;
  .record-container1 {
    display: flex;
    align-items: center;
    .point {
      width: 7px;
      height: 7px;
      border-radius: 7px;
      border: 4px solid #4084ff;
      margin-right: 13px;
    }
    .operate {
      color: #333333;
      font-size: 14px;
      font-weight: bold;
    }
  }
  .record-container2 {
    display: flex;
    height: fit-content;
    margin: 7px 0 12px 0;
    .line {
      width: 1px;
      border-left: 1px dashed #bbbbbb;
      margin: 0 20px 0 3px;
    }
    .container {
      padding: 6px 12px;
      background-color: var(--other-color);
      width: 446px;
      border-radius: 4px;
      line-height: 40px;
      color: #333333;
    }
  }
}
</style>
